import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import { Utils } from '@services/utils.service';
import { Service as ServiceStorage } from '@services/storage.service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class Service {
    private Translation: any = {};
    private uuid!: string;

    constructor(
        private Utils: Utils,
        private Router: Router,
        private HttpClient: HttpClient,
        private TranslateService: TranslateService,
        private ServiceStorage: ServiceStorage
    ) {
        this.loadUUID();
        this.TranslateService.get(['ERRORS', 'SUCCESS', 'BUTTONS']).subscribe((Translation: string) => { this.Translation = Translation; });
    }

    async loadUUID() {
        this.uuid = await this.getUUID();
    }

    async fetch(data: any, url: string, type: 'get' | 'post' | 'formdata' | 'formdata-put' | 'delete' | 'put' | 'download'): Promise<any> {
        const user_data = await this.ServiceStorage.get('user_data');
        // const current_location = await this.Utils.getCurrentLocation();
        const user_id = await this.ServiceStorage.get('user_id') || null;
        const jsonwebtoken = await this.ServiceStorage.get('jsonwebtoken');
        // const token = await this.ServiceStorage.get('token');
        const security_secret = this.Utils.encrypt(JSON.stringify({ url:url, type: type, user_id: user_data?.user_id, latitude: null, longitude: null, date: Math.floor(new Date().getTime() / 1000 )}));
        
        const headers: any = {
            'Content-Type': 'application/json',
            platform: 'admin',
            uuid: await this.getUUID(),
            version: environment.project_version,
            security_secret: security_secret
        };

        (jsonwebtoken && jsonwebtoken !== 'null') ? headers['Authorization'] = `Bearer ${jsonwebtoken}` : null;
        // (token && token !== 'null') ? headers['token'] = token : null;
        
        let return_data: any = { success: 0, data: null, error: '', reason: '' };

        let promise = new Promise<any>(async (resolve, reject) => {
            const observer = {
                next: (return_data: any) => {
                    if (return_data.error !== undefined && return_data.error === 'APP_STATUS_OFFLINE') {
                        this.Router.navigate(['/app_status/offline']);
                    } else if (return_data.error === 'NOT_SAME_AGENT' || return_data.error === 'NOT_SAME_UUID' || return_data.error === 'NOT_SAME_REMOTE_IP') {
                        this.logout();
                    }

                    resolve(return_data);
                },
                error: (error: any) => {
                    return_data.error = 'error';
                    return_data.reason = error;
                    resolve(return_data);
                },
                complete: () => {
                    // Handle any cleanup or additional actions here if needed
                }
            };

            switch (type) {
                case 'get':
                    this.HttpClient.get(url, { params: data, headers: headers }).subscribe(observer);
                    break;

                case 'delete':
                    this.HttpClient.delete(url, { params: data, headers: headers }).subscribe(observer);
                    break;

                case 'post':
                    this.HttpClient.post(url, data, { headers }).subscribe(observer);
                    break;
                    
                case 'put':
                    this.HttpClient.put(url, data, { headers }).subscribe(observer);
                    break;

                case 'formdata':
                case 'formdata-put':
                    let newFormData: FormData;

                    if (data instanceof FormData) {
                        newFormData = data;
                        /*if (!data.hasOwnProperty('token') || data.get('token') === null || data.get('token') === undefined) {
                            newFormData.append('token', await this.ServiceStorage.get('token'));
                        }*/
                    } else {
                        newFormData = new FormData();

                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                newFormData.append(key, data[key]);
                            }
                        }
                    }

                    (type == 'formdata-put')? newFormData.append('_method', 'PUT') : null;
                    // the browser must set Content-Type multipart/form-data with its own boundary
                    delete headers['Content-Type'];
                    (type == 'formdata-put')? this.HttpClient.post(url, newFormData, { headers: headers }).subscribe(observer) : this.HttpClient.post(url, newFormData, { headers: headers }).subscribe(observer);
                    break;
                
                    
                case 'download':
                    this.HttpClient.get(url, { params: data, headers: headers, responseType: 'blob', observe: 'body' }).subscribe({
                        next: (blob: Blob) => resolve(blob),
                        error: (error: any) => {
                            return_data.error = 'error';
                            return_data.reason = error;
                            resolve(return_data);
                        }
                    });
                    break;

                default:
                    resolve(return_data);
                    break;
            }
        });

        return await promise;
    }

    async logout() {
        await this.Utils.showSpiner();

        await this.ServiceStorage.remove('role');
        await this.ServiceStorage.remove('token');
        await this.ServiceStorage.remove('user');
        await this.ServiceStorage.remove('login_status');
        await this.ServiceStorage.remove('authenticated');

        // this.Router.navigateByUrl('/');
        this.Router.navigate(['/']);
        await this.Utils.closeSpiner();
    }

    async getUUID(renew: boolean = false) {
        let uuid = await this.ServiceStorage.get('uuid');

        if (!uuid || renew) {
            uuid = this.Utils.getUUID();
            await this.ServiceStorage.set('uuid', uuid);
        }

        return uuid;
    }
}
